import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NewFastMaterialComponent } from '../../wharehouse/new-fast-material/new-fast-material.component';
import { InvoiceDetaileComponent } from '../wharehouse-invoice/invoice-detaile/invoice-detaile.component';
import { ExitDetaile2Component } from '../wharehouse-exit/exit-detaile2/exit-detaile2.component';
import { WharehouseSelectComponent } from '../../wharehouse/wharehouse-select/wharehouse-select.component';
import { DecimalPipe } from '@angular/common';


@Component({
  selector: 'app-wharehouse-exit2',
  templateUrl: './wharehouse-exit2.component.html',
  styleUrls: ['./wharehouse-exit2.component.scss'],
  providers: [DecimalPipe]
})
export class WharehouseExit2Component implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  user_id: number | undefined;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  public lang: any = <any>localStorage.getItem("lang");
  list_record: any = [];
  search: string | undefined;
  page: number = 1;
  invoice_id: number | undefined;
  cate: number | undefined;
  reception_id: number | undefined;
  exit_id: number | undefined;
  list_material_type: any = [];
  material_type: number = 0;
  ref: string | undefined;
  type: number | undefined;
  list_invoice: any = [];
  new_invoice_id: number;
  sum_all: number = 0;
  sum_all_services: number;
  sum_all_material: number;
  code: number | undefined;
  id: number | undefined;
  status_id: number | undefined;
  shelf_temp: number | undefined;
  level: number = 0;
  invoice_price1: number = 0;
  creator: number | undefined;

  public count_total: number = 1;
  public page_number_first: number | undefined; public page_number_second: number | undefined;
  public pre_status: boolean | undefined; public next_status: boolean | undefined; public new_status: boolean | undefined;

  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  displayedColumns = ['row', 'material', 'cate', 'inventory', 'order', 'invoice', 'invoice_price', 'number', 'cost', 'add'];
  displayedColumns3 = ['row', 'type', 'material', 'cate', 'number', 'cost', 'sum', 'operation'];


  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<WharehouseExit2Component>
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog, private _decimalPipe: DecimalPipe) {
    if (dialog_data) {
      this.invoice_id = dialog_data.invoice_id;
      this.ref = dialog_data.ref;
      this.exit_id = dialog_data.exit_id;
      this.cate = dialog_data.cate;
      this.type = dialog_data.type;
      this.reception_id = dialog_data.reception_id;
      this.code = dialog_data.code;
      this.id = dialog_data.reception_id;
      this.creator = dialog_data.creator;
      this.level = dialog_data.level;
    }
  }//end consructor

  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.get_material_type();
    this.get(1, 1, 0);
  }

  get_material_type() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1986 }).subscribe(
      (res: any) => {
        this.list_material_type = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_material_type.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  select_material(id: number, alarm: boolean) {
    const dialogRef = this.dialog.open(WharehouseSelectComponent, {
      width: '60rem',
      height: 'auto',
      data: { id: id, alarm: alarm }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.get_select_material(id, res);
        }
      }
    )
  }

  get_select_material(id: number, order_id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6133, order_id: order_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {

          var order1 = <any>document.getElementById("order1" + id);
          order1.value = res['result'][0].wharehouse_order_id;

          var invoice1 = <any>document.getElementById("invoice1" + id);
          invoice1.innerHTML = res['result'][0].wharehouse_invoice_id;

          var invoice_price1 = <any>document.getElementById("invoice_price1" + id);
          invoice_price1.innerHTML = this._decimalPipe.transform(res['result'][0].wharehouse_order_cost);
          this.invoice_price1 = res['result'][0].wharehouse_order_cost;

          var input1 = <any>document.getElementById("input1" + id);
          //input1.value = res['result'][0].wharehouse_order_number;


          var cost1 = <any>document.getElementById("cost1" + id);
          cost1.value = res['result'][0].wharehouse_order_cost;

          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  which(page) {
    if (page == 2) { this.page = this.page + 1; }
    if (page == 3) { this.page = this.page - 1; }
    this.get(1, this.page, this.material_type);
  }

  get_search() {
    if (this.material_type > 0) {
      this.get(2, 1, this.material_type);
    } else {
      this.get_exit(2, 1);
    }
  }

  get(loading: number, page: number, id: number) {
    this.page = page;
    this.material_type = id;
    if (id == 1) {
      this.get_material(loading);
    }
    else {
      this.get_exit(1, 1);
    }
  }

  get_material(loading: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) {
      this.loading = true;
      this.search = '';
    }

    var obj = {
      address: 1886, search: this.search, page: this.page,
      cate: this.cate, creator: this.creator
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.count_total = res['count'];
          this.pages(0);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  delete_material(i: number, id: any) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var address;
      var obj = {
        'address': 6039, "user_id": this.user_id, 'id': id, page: this.page, search: []
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(i, 1);
            this.dataSource.data = this.list_record;
            this.pages(-res['result'].changedRows);
            this.message(true, this.serverService.message_delete(id, res['result'].changedRows), 1, this.serverService.message_action());
          }//end if
          else if (res['status'] == 4) {
            this.message(true, this.serverService.message_delete_alarm(), 1, this.serverService.message_action());
          }
          else {
            this.message(true, this.serverService.message_error(), 1, this.serverService.message_action());
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true      
  }//end delete 
  //******************************************************* */
  pages(count: number) {
    this.count_total = this.count_total + count;
    this.page_number_first = this.page * 30 - 29;
    this.page_number_second = this.page * 30;
    if (this.page_number_first == 1) { this.pre_status = true; this.new_status = false; }
    else { this.pre_status = false; this.new_status = true; }
    if (this.list_record.length < 30) { this.page_number_second = this.count_total; this.next_status = true }//end if
    else { this.next_status = false; }
  }

  select(id: number, title: string) {
    this.matDialogRef.close({ title: title, id: id });
  }
  //************************************************************************************************  */
  add() {
    const dialogRef = this.dialog.open(NewFastMaterialComponent, {
      width: '25rem',
      height: 'auto',
      data: { cate: this.cate, material_type: this.material_type, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.list_record.unshift(res);
          this.dataSource.data = this.list_record;
        }
      }
    )
  }

  save(i: number, id: number, number1: number, material_type: number, cost: any) {
    if (this.ref == 'exit') {
      this.check_inventory(i, id, material_type, cost);
    } else {
      var input1 = <any>document.getElementById("input1" + id);
      var number = input1.value;
      this.add_to_bascket_order(id, number);
    }
  }
  //************************************************************************************************** */


  message(validation: boolean, message: string, type: number, action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //***********************************************************************************************  */
  check_inventory(i: number, id: number, material_type: number, cost: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }

    var cost1 = <any>document.getElementById("cost1" + id);
    cost = cost1.value;

    var input1 = <any>document.getElementById("input1" + id);
    var number = input1.value;

    var order1 = <any>document.getElementById("order1" + id);
    var order1 = order1.value;

    if (!order1) {
      var pe_message = "کالای انتخابی باید از رکوردهایی باشد که قبلا خریداری شده است";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      this.select_material(id, true);
      return false;
    }
    if (!number || number == 0 || !cost || cost == 0) {
      var pe_message = "لطفا تعداد و هزینه درخواستی را مشخص نمائید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 6134, material_id: id, exit_id: this.exit_id, order_id: order1 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (input1.value <= res['remain']) {
            this.add_to_bascket_exit(i, id, number, material_type, cost);
          } else {
            var pe_message = "تعدادی درخواستی بیشتر ار موجودی انبار می باشد .لطفا اصلاح نمائید.";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  add_to_bascket_exit(i: number, id: number, number: number, material_type: number, cost: any): any {
    if (material_type == 2) {
      var cost2 = <any>document.getElementById("cost2" + id);
      cost = cost2.value;

      var input2 = <any>document.getElementById("input2" + id);
      number = input2.value;
    }
    if (!number || number == 0 || !cost || cost == 0) {
      var pe_message = "لطفا تعداد و هزینه درخواستی را مشخص نمائید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return false;
    }

    if (this.material_type == 1) {
      var cost1 = <any>document.getElementById("cost1" + id);
      if (Number(this.invoice_price1) > Number(cost1.value)) {
        var confirm = window.confirm("قیمت فروش کمتر از قیمت خرید شده است. آیا می خواهید ادامه دهید؟");
        if (confirm == false) {
          return false;
        }
      }
    }

    var order1;
    if (material_type == 1) {
      var order1 = <any>document.getElementById("order1" + id);
      var order1 = order1.value;
    }
    this.loading = true;
    var obj = {
      address: 1983, reception_id: this.reception_id, id: id, number: number, order_id: order1,
      type: this.type, user_id: this.user_id, creator: this.creator
      , material_type: material_type, cost: cost.replace(/[^0-9]/g, '')
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.dataSource.data = this.list_record;
          this.serverService.send_bascket(res['result'][0]);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //***********************************************************************************************  */
  add_to_bascket_order(id: number, number: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 1983, reception_id: this.reception_id, id: id, number: number,
      type: this.type
      , material_type: 1
      , ref: this.ref
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          var pe_message = "با موفقیت اضافه شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  //************************************************************************************************* */
  check_access3(type_task: number, page: number, id: any, excel: number, loading: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 160 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 3) {
              //this.delete_exit(id);
            }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  get_exit(loading: number, page: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.page = page;
    this.material_type = 0;
    if (loading == 1) {
      this.loading = true;
      this.search = '';
    }

    this.material_type = 0;
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1862, reception_id: this.id, page: this.page, user_id: this.user_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record = [];
          this.sum_all = 0;
          this.sum_all_material = 0;
          this.sum_all_services = 0;

          for (var i = 0; i < res['num']; i++) {

            res['result'][i].sum = res['result'][i].wharehouse_order_number * res['result'][i].cost;
            this.sum_all += res['result'][i].sum;

            if (res['result'][i].wharehouse_order_material_type == 1) {
              this.sum_all_material += res['result'][i].sum;
            }
            if (res['result'][i].wharehouse_order_material_type == 2) {
              this.sum_all_services += res['result'][i].sum;
            }

            this.list_record.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_record);
          this.count_total = res['count'];
          this.pages(0);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data


  open_detaile_exit(i: number, type_task: number, id: number, title: string, footer: boolean, material_type: number, repairman: number): any {
    if (this.level == 2 || this.user_id == repairman || repairman == null) {
      const dialogRef = this.dialog.open(ExitDetaile2Component, {
        width: '45rem',
        height: 'auto',
        disableClose: true,
        data: { type_task: type_task, id: id, material_type: material_type, i: i, code: this.code, title: title, reception_id: this.id, ref: 'reception' }
      });
      dialogRef.afterClosed().subscribe(
        (res: any) => {
          if (res) {
            if (type_task == 1) {
              this.dataSource.data = this.list_record;
              this.count_total = this.list_record;
            }
            else if (type_task == 2) {
              this.list_record[i].repairman_title = res.result.repairman_title;
              this.list_record[i].wharehouse_material_title = res.result.wharehouse_material_title;
              this.list_record[i].wharehouse_material_cate_title = res.result.wharehouse_material_cate_title;
              this.list_record[i].wharehouse_order_number = res.result.wharehouse_order_number;
              this.list_record[i].cost = res.result.cost;
              this.list_record[i].sum = res.result.sum;
              this.list_record[i].title = res.result.title;
              this.list_record[i].cost = res.result.cost;
              this.list_record[i].sum = res.result.wharehouse_order_number * res.result.cost;
            }
            this.get_amount_exit();
          }
        }
      )
    }//end if
    else {
      var pe_message = "شما دسترسی به این رکورد را ندارید.";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
    }
  }

  delete_exit(id: number, repairman: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }

    if (this.level == 2 || this.user_id == repairman || repairman == null) {
      var confirm_delete;
      confirm_delete = window.confirm(this.serverService.message_delete_accept());
      this.loading = false;
      if (confirm_delete == true) {
        this.loading = true;
        var obj = {
          'address': 1863, "user_id": this.user_id
          , 'id': id, "page": 1,
        }
        this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
          (res: any) => {
            if (res['status'] == 1) {
              this.list_record.splice(this.list_record.findIndex((index: any) => index.wharehouse_order_id == id), 1);
              this.dataSource.data = this.list_record;
              this.count_total = this.list_record.length;
              this.get_amount_exit();
              this.message(true, this.serverService.message_delete(id, res['result'].changedRows), 1, this.serverService.message_action());
            }//end if
            else if (res['status'] == 4) {
              this.message(true, this.serverService.message_delete_alarm(), 1, this.serverService.message_action());
            }
            else {
              this.message(true, this.serverService.message_error(), 1, this.serverService.message_action());
            }//end else
          }//end res:Response
        )//end this.subscription
      }//end this.confirm_delete == true    
    } else {
      var pe_message = "شما دسترسی به این سرویس را ندارید";
      var pe_action = "بستن";
      this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
    }
  }//end delete

  get_amount_exit() {
    this.sum_all = 0;
    this.sum_all_material = 0;
    this.sum_all_services = 0;
    for (var i = 0; i < this.list_record.length; i++) {
      this.sum_all = this.sum_all + this.list_record[i].sum;

      if (this.list_record[i].wharehouse_order_material_type == 1) {
        this.sum_all_material += this.list_record[i].sum;
      }
      if (this.list_record[i].wharehouse_order_material_type == 2) {
        this.sum_all_services += this.list_record[i].sum;
      }
    }

  }
  //************************************************************************************************  */

  close() {
    this.matSnackBar.dismiss();
    this.matDialogRef.close();

  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
